/*
 * SelectEmpty.tsx  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { ISelectItemProps, SelectItem } from "./SelectItem";

export interface ISelectEmptyProps extends ISelectItemProps {
	className?: string;
}

export const SelectEmpty: React.FC<ISelectEmptyProps> = ({ className, ...props }) => {
	const baseClass = BEM("edt-select-empty");

	if (className) {
		baseClass.add(className);
	}

	return <SelectItem disabled className={baseClass.toClassName()} {...props} />;
};
